import { PropertySearchFilter } from './property-search-filter';
import { Page } from '../../../shared/models/paging';

export class PropertySearchRequest {
  filter: PropertySearchFilter;
  page: Page;

  constructor(filter: PropertySearchFilter, page: Page = new Page()) {
    this.filter = filter;
    this.page = page;
  }
}
